import { listenToDesignThumbnails, type DesignThumbnailItem } from 'packages/services/designsService';
import type { SseSubscribeOptions } from '../useSseSubscribe';

type Params = {
    creativeIds: number[];
    onMessage: SseSubscribeOptions<{ items: DesignThumbnailItem[] }>['onMessage'];
};

export function sseDesignsThumbnailsOptions({
    creativeIds,
    onMessage,
}: Params): SseSubscribeOptions<{ items: DesignThumbnailItem[] }> {
    return {
        deps: creativeIds,
        // The `{ items }` re-wrap keeps the consumer's onMessage signature identical across both
        // transports.
        subscribe: (onData, onClose) => listenToDesignThumbnails(creativeIds, (items) => onData({ items }), onClose),
        onMessage,
    };
}
